








































































import Vue from "vue";
import auth, { Authentication } from "../../../services/auth";
import http, { setConnection } from "../../../services/http";
import eventBus from "@/services/eventBus";

export default Vue.extend({
  data: () => ({
    secretKey:'',
    imageData: null as string | null,
    isUserUse2FA: false,
    showConfirm: false,

  }),

  async beforeMount() {

      await http.post('login/auth', auth.userID, {
            headers: {
              'Content-Type': 'application/json'
            }
      }).then(response =>{
          if(response.data.data != null){
            this.isUserUse2FA = true           
          }
      });
        
      if(this.isUserUse2FA == false){
        await http.get(`https://auth.trufinance.hu/truauthenticator/google/setup?user=${auth.userName}&issuer=TruFinance`).then(response => {
            this.imageData = `data:image/png;base64,${response.data.code}` 
            this.secretKey = response.data.secretKey  
        });
      }
  },
  methods:{
    pushToMainPage(){
      this.$router.push("/");
    },
    saveTwoFactAuth(){
      http.post("users/set-twofactauth",{
        authType: 2,
        userid: auth.userID,
        secretKey: this.secretKey
      }).then(
        response =>{
          // console.log(response.data.data)
          if(response.data.data == "success"){
              // auth.googleAuthenticationKey = this.secretKey;
              eventBus.$emit("success", "Kétfaktoros autentikáció sikeresen beállítva.");
              this.$router.push("/");
          }
        }
      )
    },
    deleteTwoFactAuth(){
      http.post("users/delete-twofactauth",auth.userID, {
             headers: {
               'Content-Type': 'application/json'
             }
      }).then(
        response =>{
          // console.log(response.data.data)
            if(response.data.data == "success"){
              // auth.googleAuthenticationKey = '';
              eventBus.$emit("success", "Kétfaktoros autentikáció törölve.");
              this.$router.push("/");
          }
        }
      );
    }
  }

});


